import { AnimationOnScroll } from 'react-animation-on-scroll';

/**
 * Workaround for SWISSKISCHOOL-FRONTEND-2EK:
 * `react-animation-on-scroll` can throw on iOS Safari when its internal ref becomes null
 * while a timer/visibility check still runs.
 *
 * On iOS, we disable the wrapper and just render children (no animation) to avoid crashes.
 */
export default function SafeAnimationOnScroll(props: any) {
    const userAgent = typeof navigator !== 'undefined' ? (navigator.userAgent || '') : '';
    const hasMSStream = typeof window !== 'undefined' && (window as any).MSStream;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !hasMSStream;

    if (isIOS) {
        // No wrapper: keep DOM identical and avoid crashing Safari/iOS with the library.
        return props.children;
    }

    return <AnimationOnScroll {...props} />;
}
